import * as actionTypes from "../constants/actionTypes";

const switchOfferType = offerType => {
  return {
    type: actionTypes.SWITCH_OFFER_TYPE,
    offerType
  };
};

export { switchOfferType };
